<template>
    <el-card
        style="height: 99%"
        :body-style="{ height: '100%' }"
        class="mead-bike-map"
    >
        <template #header>
            <content-header />
        </template>

        <el-row type="flex" justify="center" style="height: 100%">
            <div class="amap-page-container">
                <el-amap
                    vid="amap"
                    :plugin="plugin"
                    class="amap-demo"
                    :center="center"
                    :default-cursor="defaultCursor"
                    :zoom="zoom"
                    :amap-manager="amapManager"
                    :events="events"
                >
                    <el-amap-marker
                        :position="marker.position"
                        :events="marker.events"
                        :visible="marker.visible"
                        :draggable="marker.draggable"
                        :icon="marker.icon"
                    />
                    <!-- <el-amap-marker vid="component-marker" :position="componentMarker.position" :content-render="componentMarker.contentRender"/> -->
                    <!-- <el-amap-circle
                      v-for="(circle,index) in circles"
                      :key="'info2-'+index"
                      :center="circle.center"
                      :radius="circle.radius"
                      :fill-opacity="circle.fillOpacity"
                      :events="circle.events"
                    /> -->
                    <el-amap-polygon
                        v-for="(polygon, index) in polygons"
                        :key="index"
                        :vid="index"
                        :editable="true"
                        :ref="`polygon_${index}`"
                        :fill-opacity="polygon.fillOpacity"
                        :stroke-color="polygon.strokeColor"
                        :path="polygon.path"
                        :draggable="polygon.draggable"
                        :events="polygon.events"
                    />
                </el-amap>
            </div>
            <div class="form-class">
                <lz-form
                    ref="form"
                    :get-data="getData"
                    :submit="onSubmit"
                    :errors.sync="errors"
                    :form.sync="form"
                    :edit-mode="editMode"
                    :rules="rules"
                    label-width="35%"
                    style="width: 100%"
                >
                    <!-- <el-form-item label="区域" hidden required prop="area_fence">
                    <el-input v-model="form.area_fence"/>
                  </el-form-item>
                  <el-form-item label="区域中心" hidden required prop="area_centre">
                    <el-input v-model="form.area_centre"/>
                  </el-form-item> -->
                    <!-- <el-form-item label="请在地图中绘制区域"/> -->

                    <el-form-item label="区域名称" required prop="name">
                        <el-input v-model="form.name" style="width: 80%" />
                    </el-form-item>
                    <el-form-item
                        label="区域创建者"
                        v-show="isAdmin"
                        prop="name"
                    >
                        <el-select
                            v-model="form.admin_id"
                            placeholder="请选择"
                            style="width: 80%"
                        >
                            <el-option
                                v-for="item in areaAdmin"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区域状态" required prop="status">
                        <el-switch
                            v-model="form.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="正常"
                            inactive-text="禁用"
                        />
                    </el-form-item>
                    <el-form-item
                        label="服务时间"
                        required
                        prop="customer_service_time"
                    >
                        <el-input
                            v-model="form.customer_service_time"
                            style="width: 80%"
                        />
                    </el-form-item>
                    <el-form-item
                        label="服务手机"
                        required
                        prop="customer_service_phone"
                    >
                        <el-input
                            v-model="form.customer_service_phone"
                            style="width: 80%"
                        />
                        <p style="margin: 10px; font-size: 14px; color: green">
                            请在地图中绘制区域
                        </p>
                    </el-form-item>
                    <el-form-item label="是否克隆" required prop="status">
                        <el-switch
                            style="display: block"
                            v-model="form.clone_id"
                            active-color="#13ce66"
                            :inactive-value="0"
                            :active-value="form.clone_id ? clone_id : true"
                            inactive-color="#ff4949"
                            active-text="开启"
                            inactive-text="关闭"
                            :disabled="!clone_id ? true : false"
                        />
                    </el-form-item>
                </lz-form>
                <p style="margin: 10px 22%; font-size: 11px; color: red">
                    注：红色范围为辐射范围，绿色为骑行范围
                </p>
                <p
                    style="
                        margin: 10px 22%;
                        font-size: 11px;
                        color: red;
                        width: 70%;
                    "
                >
                    注：中心点需要在绘制区域内
                </p>
            </div>
        </el-row>
    </el-card>
</template>

<script>
import VueAMap from "vue-amap";
import LzForm from "@c/LzForm";
import { editArea, storeArea, updateArea } from "@/api/area";
import { getAreaAdminUsers } from "@/api/admin-users";
import FormHelper from "@c/LzForm/FormHelper";
import _get from "lodash/get";
import store from "@/store";
import { ROLE_ADMIN } from "@/libs/constants";

export default {
    name: "Form",
    components: {
        LzForm,
    },
    mixins: [FormHelper],
    data() {
        const exampleComponents = {
            props: ["text"],
            template: `
                    <div>text from parent: {{text}}</div>`,
        };
        let amapManager = new VueAMap.AMapManager();
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            } else {
                const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入正确的手机号"));
                }
            }
        };
        return {
            isAdmin: false,
            areaAdmin: [],
            count: 1,
            slotStyle: {
                padding: "2px 8px",
                background: "#eee",
                color: "#333",
                border: "1px solid #aaa",
            },
            clone_id: 0, //当前克隆id
            zoom: 14,
            center: [121.5273285, 31.21515044],
            marker: {
                position: [121.5273285, 31.21515044],
                events: {
                    click: () => {
                        // alert('click marker')
                    },
                    dragend: (e) => {
                        this.form.area_centre = {
                            lat: e.lnglat.lat,
                            lng: e.lnglat.lng,
                        };
                        // console.log('---event---: dragend')
                        // this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
                    },
                },
                visible: true,
                draggable: true,
                icon: "http://resource.bike.hanyiyun.com/admin/area_center_20191130170212.png",
            },
            markers: [
                {
                    position: [121.5273285, 31.21515044],
                    events: {
                        click: () => {
                            // alert('click marker')
                        },
                        dragend: (e) => {
                            console.log("---event---: dragend");
                            this.markers[0].position = [
                                e.lnglat.lng,
                                e.lnglat.lat,
                            ];
                        },
                    },
                    visible: true,
                    draggable: false,
                    template: "<span>1</span>",
                },
            ],
            // circles: [
            //   {
            //     center: [121.5273285, 31.21515044],
            //     radius: 200,
            //     fillOpacity: 0.1,
            //     events: {
            //       click: () => {
            //         // alert('click')
            //       },
            //     },
            //   },
            // ],
            polygons: [
                {
                    // 骑行区
                    draggable: false,
                    fillOpacity: 0.1,
                    path: [
                        [121.5273285, 31.21515044],
                        [121.5293285, 31.21515044],
                        [121.5293285, 31.21915044],
                        [121.5273285, 31.21515044],
                    ],
                    events: {
                        change: () => {
                            this.form.area_fence = [];
                            this.polygons[0].path.forEach((item) => {
                                var im = { lat: item.lat, lng: item.lng };
                                this.form.area_fence.push(im);
                            });
                        },
                        click: () => {},
                    },
                },
                {
                    // 辐射范围
                    draggable: false,
                    fillOpacity: 0.1,
                    strokeColor: "#ff0000",
                    path: [
                        [121.5273285, 31.21515044],
                        [121.5293285, 31.21515044],
                        [121.5293285, 31.21915044],
                        [121.5273285, 31.21515044],
                    ],
                    events: {
                        change: () => {
                            this.form.area_fushe_fence = [];
                            this.polygons[1].path.forEach((item) => {
                                var im = { lat: item.lat, lng: item.lng };
                                this.form.area_fushe_fence.push(im);
                            });
                        },
                        click: () => {},
                    },
                },
            ],
            form: {
                name: "",
                area_fence: [],
                area_fushe_fence: [],
                area_centre: "",
                status: true,
                admin_id: 0,
                customer_service_time: "",
                customer_service_phone: "",
            },
            rules: {
                customer_service_phone: [
                    { validator: checkPhone, trigger: "blur" },
                ],
            },
            errors: {},
            defaultCursor: "pointer",
            amapManager: amapManager,
            events: {
                init(o) {},
            },
            componentMarker: {
                position: [121.5273285, 31.21315058],
                contentRender: (h, instance) =>
                    h(
                        exampleComponents,
                        {
                            style: { backgroundColor: "#fff" },
                            props: { text: "father is here" },
                        },
                        ["xxxxxxx"]
                    ),
            },
            plugin: [
                {
                    pName: "Geolocation",
                    events: {
                        init(o) {
                            // o 是高德地图定位插件实例
                            // console.log(o)
                            o.getCurrentPosition((status, result) => {
                                // 未配置https  定位失败 暂时手动配置
                                self.lng = 113.73350255780726;
                                self.lat = 34.78024666564106;
                                // self.center = [self.lng, self.lat]
                                self.loaded = true;
                                if (result && result.position) {
                                    self.lng = result.position.lng;
                                    self.lat = result.position.lat;
                                    // self.center = [self.lng, self.lat]
                                    // self.loaded = true
                                    // self.$nextTick()
                                }
                            });
                        },
                    },
                },
                {
                    pName: "Scale",
                    // offset: { x: 1, y: 1 },
                    position: "RB",
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                },
                {
                    pName: "ToolBar",
                    events: {
                        init(instance) {
                            // console.log(instance)
                        },
                    },
                },
            ],
        };
    },
    async created() {
        const userRoles = _get(store, "state.users.user.roles", []);

        if (userRoles.indexOf(ROLE_ADMIN) !== -1) {
            this.isAdmin = true;
        }
        const { data: areaAdmin } = await getAreaAdminUsers();
        this.areaAdmin = areaAdmin;
        // console.log(areaAdmin)
    },
    methods: {
        async onSubmit() {
            if (this.editMode) {
                if (this.form.clone_id == true) {
                    this.form.clone_id = this.clone_id;
                }
                await updateArea(this.resourceId, this.form);
            } else {
                await storeArea(this.form);
            }
        },
        async getData() {
            let _this = this;
            if (_this.editMode) {
                const { data } = await editArea(_this.resourceId);
                // console.log(data)
                _this.form.admin_id = parseInt(data.admin_id);
                console.log(_this.form.admin_id);
                _this.form.name = data.name;
                _this.form.status = data.status;
                _this.form.clone_id = data.clone_id;
                _this.clone_id = data.clone_id;
                _this.form.customer_service_phone = data.customer_service_phone;
                _this.form.customer_service_time = data.customer_service_time;
                // 表单区域赋值
                _this.form.area_fence = JSON.parse(data.area_fence);
                _this.form.area_fushe_fence = JSON.parse(data.area_fushe_fence);
                var old_area_centre = JSON.parse(data.area_centre);
                _this.form.area_centre = {
                    lng: old_area_centre[0],
                    lat: old_area_centre[1],
                };

                // console.log(_this.form)
                // 地图区域赋值
                _this.marker.position = JSON.parse(data.area_centre);
                _this.polygons[0].path = JSON.parse(data.area_fence); // 骑行区域渲染
                _this.polygons[1].path = JSON.parse(data.area_fushe_fence); // 骑行辐射区域渲染
                // _this.circles[0].radius = data.area_radius
                // _this.circles[0].center = JSON.parse(data.area_centre)

                _this.center = JSON.parse(data.area_centre);
                _this.markers.position = JSON.parse(data.area_centre); // 中心点渲染
            } else {
                // 初始化表单 区域
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.amap-page-container {
    width: 75%;
    position: relative;
}

.amap-demo {
    /*height: 88%;*/
}

.info {
    border-radius: 0.25rem;
    position: absolute;
    top: 70px;
    width: auto;
    border-width: 0;
    right: 20px;
}

.search-box {
    height: 36px;
    border-radius: 0.25rem;
    top: 65px;
    border-width: 1px;
    left: 90px;
}

.form-class {
    width: 25%;
    overflow: auto;
}
</style>
